<template>
	<div
		class="specs-table__column-container"
		:class="{ 'specs-table__column-container--show': isPrebuildSelected }"
	>
		<specs-column
			:prebuild="columnPrebuild"
			:prebuild-games="prebuildGames"
			:variant="columnVariant"
			:show-more-specs="showMoreSpecs"
			:show-categories="showCategories"
		>
			<h4 class="specs-table__heading">
				<span class="specs-table__heading__name">
					<small>{{ columnPrebuild.name.small }}</small>
					{{ columnPrebuild.name.rest }}

					<template v-if="PREBUILD_ICONS_BY_SLUG[columnPrebuild.slug]">
						<span
							:class="PREBUILD_ICONS_BY_SLUG[columnPrebuild.slug].class"
							v-html="PREBUILD_ICONS_BY_SLUG[columnPrebuild.slug].icon"
						/>
					</template>
				</span>
				<span class="specs-table__heading__price">
					<promo-sales-timed>
						<template v-slot:originalContent>
							${{ columnVariant.price.amount
							}}<small>.{{ columnVariant.price.cents }}</small>
						</template>
						<template>
							${{ promoDiscount(columnVariant.price.full) }}
							<span class="discounted-price">
								${{ columnVariant.price.full }}
							</span>
						</template>
					</promo-sales-timed>
				</span>
			</h4>
		</specs-column>
	</div>
</template>

<script>
import SpecsColumn from "../specs-column";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { PREBUILD_ICONS_BY_SLUG } from "../../constants";
import VariantStrategy from "./variant-strategy";
import { promoDiscount } from "@u/helpers";

export default {
	name: "SpecsPrebuild",
	components: {
		SpecsColumn,
		PromoSalesTimed
	},
	props: {
		index: {
			type: Number,
			default: 0
		},
		showMoreSpecs: {
			type: Boolean,
			required: true
		},
		prebuild: {
			type: Object,
			default() {
				return {};
			}
		},
		currentPrebuildId: {
			type: String,
			default: ""
		},
		currentVariantId: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			PREBUILD_ICONS_BY_SLUG
		};
	},
	computed: {
		showCategories() {
			const PORTRAIT_TABLET_BREAKPOINT = 991;
			const IS_SMALL_DEVICE = $(window).width() <= PORTRAIT_TABLET_BREAKPOINT;
			const IS_FIRST_PREBUILD = this.index === 0;
			return IS_SMALL_DEVICE || IS_FIRST_PREBUILD;
		},
		isPrebuildSelected() {
			return this.columnPrebuild.id === this.currentPrebuildId;
		},
		variantScenario() {
			return this.isPrebuildSelected ? "selected" : "default";
		},
		columnPrebuild() {
			const { small, rest } = this.getSeparatedName(this.prebuild.name);

			return {
				...this.prebuild,
				name: {
					small,
					rest
				}
			};
		},
		columnVariant() {
			return VariantStrategy[this.variantScenario].get({
				variants: this.columnPrebuild.variants,
				selectedId: this.currentVariantId
			});
		},
		prebuildGames() {
			return this.prebuild.games;
		}
	},
	methods: {
		promoDiscount,
		getSeparatedName(name = "") {
			const regex = /[\w]+/g;
			const [small, ...rest] = name.match(regex);
			return {
				small,
				rest: rest.join(" ")
			};
		}
	}
};
</script>
<style lang="scss" scoped>
.specs-table__heading::v-deep {
	.discounted-price {
		color: #5f707f;
		margin-bottom: 0;
		font-size: 16px;
		font-weight: normal;
		text-decoration: line-through;
	}
}

.specs-table {
	&__column-container {
		display: none;

		@media (min-width: 991px) {
			display: block;
		}
	}

	&__column-container--show {
		display: block;
	}

	&__heading {
		grid-column: 2;
		margin: 0;
		align-items: flex-end;
		justify-content: space-between;
		padding: 25px 15px;
		border-bottom: solid 2px #444259;
		display: none;

		@media (min-width: 991px) {
			display: flex;
		}

		&__name {
			margin: 0;
			font-size: 24px;
			color: #444259;
			font-weight: bold;
			letter-spacing: 0;
			position: relative;

			.cross,
			.diamond {
				position: absolute;
			}

			.cross {
				color: #e45e39;
				font-size: 18px;
				right: -15px;
				top: 15px;
			}

			.diamond {
				color: #0076ff;
				font-size: 20px;
				right: -7px;
				top: 13px;
			}

			small {
				display: block;
				color: rgba(68, 66, 89, 0.8);
				font-size: 14px;
				letter-spacing: 0;
				font-weight: bold;
			}
		}

		&__price {
			font-size: 24px;
			color: #444259;

			small {
				font-size: 16px;
				color: #444259;
			}
		}
	}

	&__gray-column {
		@media (min-width: 991px) {
			background: #f3f3f3;
		}
	}
}
</style>
